// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"21d59cd3","310":"c9945a64","321":"40393a1f","787":"b9ec5bb0"}[chunkId] + ".chunk.js";
};